var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcademicStatusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bars-staggered-solid_1_",
    "data-name": "bars-staggered-solid (1)",
    d: "M0,65.5A1.5,1.5,0,0,1,1.5,64h18a1.5,1.5,0,0,1,0,3H1.5A1.5,1.5,0,0,1,0,65.5ZM3,73a1.5,1.5,0,0,1,1.5-1.5h18a1.5,1.5,0,0,1,0,3H4.5A1.5,1.5,0,0,1,3,73Zm18,7.5A1.5,1.5,0,0,1,19.5,82H1.5a1.5,1.5,0,0,1,0-3h18A1.5,1.5,0,0,1,21,80.5Z",
    transform: "translate(0 -64)",
    fill: "#c9c9c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicStatusIcon);
export default __webpack_public_path__ + "static/media/academic-status-icon.5a03faa28e740ce3f326cd9b9df44ca0.svg";
export { ForwardRef as ReactComponent };